module.exports = __webpack_public_path__ + "static/media/Dining Room Sets.4288700e.webp";